<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">
            <Row justify="space-between" class="code-row-bg">
              <Col span="6">申请时间：
                <DatePicker v-model="value2"  format="yyyy/MM/dd" type="daterange"  placeholder="选择时间" style="width: 200px"></DatePicker></Col>
              <Col span="6"> 审核状态：
                <Select v-model="value1" clearable style="width:200px">
                  <Option v-for="item in options" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select></Col>
              <Col span="6">
                <Input class="search-input" v-model="searchVal" style="width: 200px;" clearable placeholder="输入关键字全局搜索" @on-enter="searchinput"  />
                <Button type="primary" class="search-btn" align="right" @click="searchinput">搜索</Button></Col>
              <Col span="6">            <Button type="error" class="search-btn" align="right" @click="handlerDelete">批量删除</Button></Col>
            </Row>





          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>

          <el-table
            @selection-change="handleSelectChange"
            size="small"
            :data="tableData"
            style="width: 100%"
            max-height="670"
            border
            >
            <el-table-column
              type="selection"
              fixed>
            </el-table-column>
            <el-table-column
              fixed
              prop="uname"
              label="姓名"
              width="100"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="usex"
              label="性别"
              width="80"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="utype"
              label="医保类型"
              width="110"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="usfz"
              label="身份证"
              width="180"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="uaddress"
              label="参保地家庭地址"
              width="300"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="usertype"
              label="人员类别"
              width="170"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="area"
              label="居外就医行政区划"
              width="180"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              width="120"
              align="center"
              sortable>
            </el-table-column>
            <el-table-column
              prop="addtime"
              label="申请时间"
              width="100"
              align="center"
              sortable>
            </el-table-column>

            <el-table-column
              fixed="right"
              prop="pic"
              label="异地居住证明材料"
              width="150"
              align="center"
              sortable> <template slot-scope="scope">

              <el-image
                style="width: 100px; height: 100px"
                :src=scope.row.pic
                :preview-src-list=scope.row.piclist>
              </el-image>
            </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="状态"
              width="80"
              align="center"
              sortable>

            <template slot-scope="scope">
              <Tag color="green" v-if="scope.row.state==1">通过</Tag>
              <Tag color="cyan" v-if="scope.row.state==0">未审核</Tag>
              <Tag color="red" v-if="scope.row.state==2">不通过</Tag>
            </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="150"
              align="center"
              > <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="editModal(scope)">操作</el-button>

              <el-button
                size="mini"
                type="danger"
                @click="delData(scope)">删除</el-button>
            </template>
            </el-table-column>
          </el-table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :label-width="100">
              <FormItem
                label="说明"
                prop="Pname"
              >
                <Input v-model="formValidate.verifyremark" type="textarea" :rows="4"  />

              </FormItem>

              <FormItem>
                <Button
                  type="success"
                  @click="verify(formValidate,1)"
                >通过
                </Button>
                <Button
                  type="danger"
                  @click="verify(formValidate,2)"
                >不通过
                </Button>

              </FormItem>


            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="spinShow"></Spin>

  </div>
</template>

<script>


  import {
    getallopatrylist,
    operationallopatry
  } from '@/api/allopatry/allopatry.js'

  import {getsysparameterList} from "@/api/system/sys_parameter";

  let moment = require("moment");
  export default {

    data() {
      return {
        modalMap: {
          modalVisible: false,
          modalTitle: "审核说明"
        },
        spinShow:false,
        fullscreenLoading:false,
        formValidate: {},
        searchVal: "",
        tableData: [],
        tableSelectIdList:[],
        editModalData: "",
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        options: [{
          value: 0,
          label: '未审核'
        }, {
          value: 1,
          label: '审核通过'
        }, {
          value: 2,
          label: '审核不通过'
        }],
        value: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        value1: '',
        value2: ''

      };
    },
    methods: {
      getAllopatrylist(key) {
        this.spinShow = true
        // dates = dates.getDate()

        var sedate =''
        if (this.value2[0]){
          sedate = this.dateFormat("YYYY-mm-dd", this.value2[0]) + ',' + this.dateFormat("YYYY-mm-dd", this.value2[1])
        }

        getallopatrylist(this.pageNum, this.pageSize, key, sedate, this.value1).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },
      // table 选中的ID
      handleSelectChange(val) {
        let SelectIdList = []
        val.forEach(item => {
          SelectIdList.push(item.id)
        })

        this.tableSelectIdList = SelectIdList
      },
      closeModal() {
        this.dialog.show = false
      },
      handleReset(name) {
        this.$refs[name].resetFields();
      },
      handlerDelete() {
        //console.log(this.tableSelectIdList.length)
        if (this.tableSelectIdList.length > 0) {
          if (confirm(`确定要批量删除选中申请者嘛？ `)) {
            operationallopatry({'id_list': this.tableSelectIdList}, 'delete').then(
              res => {
                if (res.data.code === 0) {
                  this.$Message.success(`${res.data.msg}`)
                  this.getAllopatrylist(this.searchVal)
                } else {
                  this.$Message.error(`${res.data.msg}`)
                }
              })
          }
        } else {
          this.$Message.info(`你总要选中点什么吧`)
        }
      },
      editModal(paramsRow) {
        this.modalMap.modalVisible = true;
        this.formValidate = {
          id: paramsRow.row.id,
          uname: paramsRow.row.uname,
          verifyremark:''
        }
      },
      verify(params,v) {
        if (v == 1){
          if (confirm(`确定通过 ${params.uname}的申请嘛？`)) {
            // console.log(params.row.id)
            operationallopatry(
              {
                'Id': params.id,
                'verify': v,
                'verifyremark':params.verifyremark
              },
              'put'
            ).then(res => {

              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.modalMap.modalVisible = false
                if (this.searchVal) {

                  this.getAllopatrylist(this.searchVal)
                }else{

                  this.getAllopatrylist()

                }
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }
        }
        if (v == 2){
          if (confirm(`确定不通过 ${params.uname}的申请嘛？`)) {
            // console.log(params.row.id)
            operationallopatry(
              {
                'Id': params.id,
                'verify': v,
                'verifyremark':params.verifyremark
              },
              'put'
            ).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                this.modalMap.modalVisible = false
                if (this.searchVal) {
                  this.getAllopatrylist(this.searchVal)
                }else{
                  this.getAllopatrylist()
                }
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }
        }

      },
      // 删除
      delData(params) {
        if (confirm(`确定要删除 ${params.row.uname}的申请嘛？`)) {
          // console.log(params.row.id)
          operationallopatry(
            {
              'Id': params.row.id
            },
            'delete'
          ).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.tableData.splice(params.index, 1)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }
      },


      // 点击节点
      // 翻页
      changePage(value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getAllopatrylist(this.searchVal)
        }else{

          this.getAllopatrylist()

        }
      },
      // 切换分页
      handlePageSize(value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getAllopatrylist(this.searchVal)
        }else{
          this.getAllopatrylist()
        }
      },
      searchinput(){
        console.log(this.searchVal)
        if (this.searchVal) {

          this.getAllopatrylist(this.searchVal)
        }else{

          this.getAllopatrylist()
        }
      },
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(),        // 年
          "m+": (date.getMonth() + 1).toString(),     // 月
          "d+": date.getDate().toString(),            // 日
          "H+": date.getHours().toString(),           // 时
          "M+": date.getMinutes().toString(),         // 分
          "S+": date.getSeconds().toString()          // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
          };
        };
        return fmt;
      }


    },

    watch: {
      searchVal(val) {
        this.searchVal = val
        // this.getServerList(this.searchVal)
      }
    },
    mounted() {
      this.getAllopatrylist();

    }
  }

</script>

<style lang="css" >
.el-drawer {
  overflow: auto;
}
</style>

<style lang="less" scoped>


  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
